export const LOAD_PARTNERS_STARTED = "LOAD_PARTNERS_STARTED";
export const LOAD_PARTNERS_SUCCEEDED = "LOAD_PARTNERS_SUCCEEDED";
export const LOAD_PARTNERS_FAILED = "LOAD_PARTNERS_FAILED";
export const PARTNER_LIST_INVALIDATED = "PARTNER_LIST_INVALIDATED";

export const LOAD_PARTNER_TYPES_SUCCEEDED = "LOAD_PARTNER_TYPES_SUCCEEDED";
export const LOAD_PARTNER_TYPES_FAILED = "LOAD_PARTNER_TYPES_FAILED";

export const LOAD_CLIENT_BY_CARD_STARTED = "LOAD_CLIENT_BY_CARD_STARTED";
export const LOAD_CLIENT_BY_CARD_SUCCEEDED = "LOAD_CLIENT_BY_CARD_SUCCEEDED";
export const LOAD_CLIENT_BY_CARD_FAILED = "LOAD_CLIENT_BY_CARD_FAILED";
export const CONSUME_ADDRESS_FROM_OCR = "CONSUME_ADDRESS_FROM_OCR";

export const LOAD_LOCATIONS_SUCCEEDED = "LOAD_LOCATIONS_SUCCEEDED";
export const LOAD_LOCATIONS_FAILED = "LOAD_LOCATIONS_FAILED";

export const LOAD_PARTNER_CONFIG_SUCCEEDED = "LOAD_PARTNER_CONFIG_SUCCEEDED";
export const LOAD_PARTNER_CONFIG_FAILED = "LOAD_PARTNER_CONFIG_FAILED";

export const LOAD_PARTNER_STARTED = "LOAD_PARTNER_STARTED";
export const LOAD_PARTNER_SUCCEEDED = "LOAD_PARTNER_SUCCEEDED";
export const LOAD_PARTNER_FAILED = "LOAD_PARTNER_FAILED";

export const LOAD_PARTNER_DETAILS_STARTED = "LOAD_PARTNER_DETAILS_STARTED";
export const LOAD_PARTNER_DETAILS_SUCCEEDED = "LOAD_PARTNER_DETAILS_SUCCEEDED";
export const LOAD_PARTNER_DETAILS_FAILED = "LOAD_PARTNER_DETAILS_FAILED";
export const LOAD_PARTNERS_DETAILS_SUCCEEDED = "LOAD_PARTNERS_DETAILS_SUCCEEDED";

export const LOAD_PERSONS_SUCCEEDED = "LOAD_PERSONS_SUCCEEDED";
export const LOAD_PERSONS_FAILED = "LOAD_PERSONS_FAILED";

export const LOAD_POSITIONS_SUCCEEDED = "LOAD_POSITIONS_SUCCEEDED";
export const LOAD_POSITIONS_FAILED = "LOAD_POSITIONS_FAILED";

export const LOAD_CONTACT_MODES_SUCCEEDED = "LOAD_CONTACT_MODES_SUCCEEDED";
export const LOAD_CONTACT_MODES_FAILED = "LOAD_CONTACT_MODES_FAILED";

export const LOAD_CITIZENSHIPS_SUCCEEDED = "LOAD_CITIZENSHIPS_SUCCEEDED";
export const LOAD_CITIZENSHIPS_FAILED = "LOAD_CITIZENSHIPS_FAILED";

export const LOAD_GENDER_TYPES_SUCCEEDED = "LOAD_GENDER_TYPES_SUCCEEDED";
export const LOAD_GENDER_TYPES_FAILED = "LOAD_GENDER_TYPES_FAILED";

export const LOAD_PERSON_DOCUMENT_TYPES_SUCCEEDED = "LOAD_PERSON_DOCUMENT_TYPES_SUCCEEDED";
export const LOAD_PERSON_DOCUMENT_TYPES_FAILED = "LOAD_PERSON_DOCUMENT_TYPES_FAILED";

export const LOAD_MARITAL_STATUSES_SUCCEEDED = "LOAD_MARITAL_STATUSES_SUCCEEDED";
export const LOAD_MARITAL_STATUSES_FAILED = "LOAD_MARITAL_STATUSES_FAILED";

export const LOAD_SPECIAL_RELATIONS_SUCCEEDED = "LOAD_SPECIAL_RELATIONS_SUCCEEDED";
export const LOAD_SPECIAL_RELATIONS_FAILED = "LOAD_SPECIAL_RELATIONS_FAILED";

export const LOAD_LEGAL_FORMS_SUCCEEDED = "LOAD_LEGAL_FORMS_SUCCEEDED";
export const LOAD_LEGAL_FORMS_FAILED = "LOAD_LEGAL_FORMS_FAILED";

export const LOAD_COUNTRIES_SUCCEEDED = "LOAD_COUNTRIES_SUCCEEDED";
export const LOAD_COUNTRIES_FAILED = "LOAD_COUNTRIES_FAILED";

export const LOAD_COUNTIES_SUCCEEDED = "LOAD_COUNTIES_SUCCEEDED";
export const LOAD_COUNTIES_FAILED = "LOAD_COUNTIES_FAILED";

export const LOAD_CITIES_SUCCEEDED = "LOAD_CITIES_SUCCEEDED";
export const LOAD_CITIES_FAILED = "LOAD_CITIES_FAILED";

export const LOAD_ADDRESS_TYPES_SUCCEEDED = "LOAD_ADDRESS_TYPES_SUCCEEDED";
export const LOAD_ADDRESS_TYPES_FAILED = "LOAD_ADDRESS_TYPES_FAILED";

export const LOAD_BANK_ACCOUNTS_STARTED = "LOAD_BANK_ACCOUNTS_STARTED";
export const LOAD_BANK_ACCOUNTS_SUCCEEDED = "LOAD_BANK_ACCOUNTS_SUCCEEDED";
export const LOAD_BANK_ACCOUNTS_FAILED = "LOAD_BANK_ACCOUNTS_FAILED";

export const LOAD_PARTNER_BANK_ACCOUNTS_SUMMARY_STARTED = "LOAD_PARTNER_BANK_ACCOUNTS_SUMMARY_STARTED";
export const LOAD_PARTNER_BANK_ACCOUNTS_SUMMARY_SUCCEEDED = "LOAD_PARTNER_BANK_ACCOUNTS_SUMMARY_SUCCEEDED";
export const LOAD_PARTNER_BANK_ACCOUNTS_SUMMARY_FAILED = "LOAD_PARTNER_BANK_ACCOUNTS_SUMMARY_FAILED";

export const LOAD_ACTIVITY_FIELDS_STARTED = "LOAD_ACTIVITY_FIELDS_STARTED";
export const LOAD_ACTIVITY_FIELDS_SUCCEEDED = "LOAD_ACTIVITY_FIELDS_SUCCEEDED";
export const LOAD_ACTIVITY_FIELDS_FAILED = "LOAD_ACTIVITY_FIELDS_FAILED";

export const LOAD_PARTNER_ACTIVITY_FIELDS_SUMMARY_STARTED = "LOAD_ACTIVITY_FIELDS_SUMMARY_STARTED";
export const LOAD_PARTNER_ACTIVITY_FIELDS_SUMMARY_SUCCEEDED = "LOAD_ACTIVITY_FIELDS_SUMMARY_SUCCEEDED";
export const LOAD_PARTNER_ACTIVITY_FIELDS_SUMMARY_FAILED = "LOAD_ACTIVITY_FIELDS_SUMMARY_FAILED";

export const LOAD_PARTNER_CONTACT_MODES_STARTED = "LOAD_PARTNER_CONTACT_MODES_STARTED";
export const LOAD_PARTNER_CONTACT_MODES_SUCCEEDED = "LOAD_PARTNER_CONTACT_MODES_SUCCEEDED";
export const LOAD_PARTNER_CONTACT_MODES_FAILED = "LOAD_PARTNER_CONTACT_MODES_FAILED";

export const LOAD_CONTACT_INFOS_STARTED = "LOAD_CONTACT_INFOS_STARTED";
export const LOAD_CONTACT_INFOS_SUCCEEDED = "LOAD_CONTACT_INFOS_SUCCEEDED";
export const LOAD_CONTACT_INFOS_FAILED = "LOAD_CONTACT_INFOS_FAILED";
export const PARTNER_CONTACT_MODES_INVALIDATED = "PARTNER_CONTACT_MODES_INVALIDATED";

export const LOAD_PARTNER_CONTACT_INFO_SUMMARY_STARTED = "LOAD_PARTNER_CONTACT_INFO_SUMMARY_STARTED";
export const LOAD_PARTNER_CONTACT_INFO_SUMMARY_SUCCEEDED = "LOAD_PARTNER_CONTACT_INFO_SUMMARY_SUCCEEDED";
export const LOAD_PARTNER_CONTACT_INFO_SUMMARY_FAILED = "LOAD_PARTNER_CONTACT_INFO_SUMMARY_FAILED";

export const LOAD_CURRENCIES_SUCCEEDED = "LOAD_CURRENCIES_SUCCEEDED";
export const LOAD_CURRENCIES_FAILED = "LOAD_CURRENCIES_FAILED";

export const LOAD_BANK_ACCOUNT_TYPES_SUCCEEDED = "LOAD_BANK_ACCOUNT_TYPES_SUCCEEDED";
export const LOAD_BANK_ACCOUNT_TYPES_FAILED = "LOAD_BANK_ACCOUNT_TYPES_FAILED";

export const LOAD_BANKS_SUCCEEDED = "LOAD_BANKS_SUCCEEDED";
export const LOAD_BANKS_FAILED = "LOAD_BANKS_FAILED";

export const LOAD_PARTNER_CONSENTS_STARTED = "LOAD_PARTNER_CONSENTS_STARTED";
export const LOAD_PARTNER_CONSENTS_SUCCEEDED = "LOAD_PARTNER_CONSENTS_SUCCEEDED";
export const LOAD_PARTNER_CONSENTS_FAILED = "LOAD_PARTNER_CONSENTS_FAILED";

export const LOAD_PROPERTY_DETAILS_STARTED = "LOAD_PROPERTY_DETAILS_STARTED";
export const LOAD_PROPERTY_DETAILS_SUCCEEDED = "LOAD_PROPERTY_DETAILS_SUCCEEDED";
export const LOAD_PROPERTY_DETAILS_FAILED = "LOAD_PROPERTY_DETAILS_FAILED";

export const LOAD_ADDRESS_LIST_STARTED = "LOAD_ADDRESS_LIST_STARTED";
export const LOAD_ADDRESS_LIST_SUCCEEDED = "LOAD_ADDRESS_LIST_SUCCEEDED";
export const LOAD_ADDRESS_LIST_FAILED = "LOAD_ADDRESS_LIST_FAILED";

export const LOAD_PARTNER_ADDRESSES_SUMMARY_STARTED = "LOAD_PARTNER_ADDRESSES_SUMMARY_STARTED";
export const LOAD_PARTNER_ADDRESSES_SUMMARY_SUCCEEDED = "LOAD_PARTNER_ADDRESSES_SUMMARY_SUCCEEDED";
export const LOAD_PARTNER_ADDRESSES_SUMMARY_FAILED = "LOAD_PARTNER_ADDRESSES_SUMMARY_FAILED";

export const LOAD_SHAREHOLDERS_STARTED = "LOAD_SHAREHOLDERS_STARTED";
export const LOAD_SHAREHOLDERS_SUCCEEDED = "LOAD_SHAREHOLDERS_SUCCEEDED";
export const LOAD_SHAREHOLDERS_FAILED = "LOAD_SHAREHOLDERS_FAILED";

export const LOAD_PROPERTIES_STARTED = "LOAD_PROPERTIES_STARTED";
export const LOAD_PROPERTIES_SUCCEEDED = "LOAD_PROPERTIES_SUCCEEDED";
export const LOAD_PROPERTIES_FAILED = "LOAD_PROPERTIES_FAILED";

export const LOAD_LEGAL_PARTNER_STARTED = "LOAD_LEGAL_PARTNER_STARTED";
export const LOAD_LEGAL_PARTNER_SUCCEEDED = "LOAD_LEGAL_PARTNER_SUCCEEDED";
export const LOAD_LEGAL_PARTNER_FAILED = "LOAD_LEGAL_PARTNER_FAILED";

export const LOAD_PERSON_STARTED = "LOAD_PERSON_STARTED";
export const LOAD_PERSON_SUCCEEDED = "LOAD_PERSON_SUCCEEDED";
export const LOAD_PERSON_FAILED = "LOAD_PERSON_FAILED";

export const LOAD_PARTNER_EXTENSION_STARTED = "LOAD_PARTNER_EXTENSION_STARTED";
export const LOAD_PARTNER_EXTENSION_SUCCEEDED = "LOAD_PARTNER_EXTENSION_SUCCEEDED";
export const LOAD_PARTNER_EXTENSION_FAILED = "LOAD_PARTNER_EXTENSION_FAILED";

export const LOAD_SCORING_GRIDS_SUCCESS = "LOAD_SCORING_GRIDS_SUCCESS";
export const LOAD_SCORING_GRIDS_STARTED = "LOAD_SCORING_GRIDS_STARTED";
export const LOAD_SCORING_GRIDS_FAILED = "LOAD_SCORING_GRIDS_FAILED";

export const LOAD_SCORING_CATEGORY_OPTIONS_SUCCESS = "LOAD_SCORING_CATEGORY_OPTIONS_SUCCESS";
export const LOAD_SCORING_CATEGORY_OPTIONS_STARTED = "LOAD_SCORING_CATEGORY_OPTIONS_STARTED";

export const LOAD_DIMENSION_PERIODS_SUCCESS = "LOAD_DIMENSION_PERIODS_SUCCESS";

export const UPDATE_COMPANY_STARTED = "UPDATE_COMPANY_STARTED";
export const UPDATE_COMPANY_SUCCEEDED = "UPDATE_COMPANY_SUCCEEDED";
export const UPDATE_COMPANY_FAILED = "UPDATE_COMPANY_FAILED";

export const UPDATE_INDIVIDUAL_STARTED = "UPDATE_INDIVIDUAL_STARTED";
export const UPDATE_INDIVIDUAL_SUCCEEDED = "UPDATE_INDIVIDUAL_SUCCEEDED";
export const UPDATE_INDIVIDUAL_FAILED = "UPDATE_INDIVIDUAL_FAILED";

export const UPDATE_PROPERTIES_STARTED = "UPDATE_PROPERTIES_STARTED";
export const UPDATE_PROPERTIES_SUCCEEDED = "UPDATE_PROPERTIES_SUCCEEDED";
export const UPDATE_PROPERTIES_FAILED = "UPDATE_PROPERTIES_FAILED";

export const UPDATE_LOGO_STARTED = "UPDATE_LOGO_STARTED";
export const UPDATE_LOGO_SUCCEEDED = "UPDATE_LOGO_SUCCEEDED";
export const UPDATE_LOGO_FAILED = "UPDATE_LOGO_FAILED";

export const UPDATE_ADDRESS_STARTED = "UPDATE_ADDRESS_STARTED";
export const UPDATE_ADDRESS_SUCCEEDED = "UPDATE_ADDRESS_SUCCEEDED";
export const UPDATE_ADDRESS_FAILED = "UPDATE_ADDRESS_FAILED";

export const UPDATE_BANK_ACCOUNTS_STARTED = "UPDATE_BANK_ACCOUNTS_STARTED";
export const UPDATE_BANK_ACCOUNTS_SUCCEEDED = "UPDATE_BANK_ACCOUNTS_SUCCEEDED";
export const UPDATE_BANK_ACCOUNTS_FAILED = "UPDATE_BANK_ACCOUNTS_FAILED";

export const UPDATE_ACTIVITY_FIELDS_STARTED = "UPDATE_ACTIVITY_FIELDS_STARTED";
export const UPDATE_ACTIVITY_FIELDS_SUCCEEDED = "UPDATE_ACTIVITY_FIELDS_SUCCEEDED";
export const UPDATE_ACTIVITY_FIELDS_FAILED = "UPDATE_ACTIVITY_FIELDS_FAILED";

export const UPDATE_CONTACT_MODES_STARTED = "UPDATE_CONTACT_MODES_STARTED";
export const UPDATE_CONTACT_MODES_SUCCEEDED = "UPDATE_CONTACT_MODES_SUCCEEDED";
export const UPDATE_CONTACT_MODES_FAILED = "UPDATE_CONTACT_MODES_FAILED";

export const UPDATE_CONTACT_INFOS_STARTED = "UPDATE_CONTACT_INFOS_STARTED";
export const UPDATE_CONTACT_INFOS_SUCCEEDED = "UPDATE_CONTACT_INFOS_SUCCEEDED";
export const UPDATE_CONTACT_INFOS_FAILED = "UPDATE_CONTACT_INFOS_FAILED";

export const UPDATE_SHAREHOLDERS_STARTED = "UPDATE_SHAREHOLDERS_STARTED";
export const UPDATE_SHAREHOLDERS_SUCCEEDED = "UPDATE_SHAREHOLDERS_SUCCEEDED";
export const UPDATE_SHAREHOLDERS_FAILED = "UPDATE_SHAREHOLDERS_FAILED";

export const UPDATE_CONSENTS_STARTED = "UPDATE_CONSENTS_STARTED";
export const UPDATE_CONSENTS_SUCCEEDED = "UPDATE_CONSENTS_SUCCEEDED";
export const UPDATE_CONSENTS_FAILED = "UPDATE_CONSENTS_FAILED";

export const UPDATE_PARTNER_SUCCEEDED = "UPDATE_PARTNER_SUCCEEDED";

export const LOAD_PARTNER_SHAREHOLDERS_SUMMARY_STARTED = "LOAD_PARTNER_SHAREHOLDERS_SUMMARY_STARTED";
export const LOAD_PARTNER_SHAREHOLDERS_SUMMARY_SUCCEEDED = "LOAD_PARTNER_SHAREHOLDERS_SUMMARY_SUCCEEDED";
export const LOAD_PARTNER_SHAREHOLDERS_SUMMARY_FAILED = "LOAD_PARTNER_SHAREHOLDERS_SUMMARY_FAILED";

export const LOAD_DEALERS_STARTED = "LOAD_DEALERS_STARTED";
export const LOAD_DEALERS_SUCCEEDED = "LOAD_DEALERS_SUCCEEDED";
export const LOAD_DEALERS_FAILED = "LOAD_DEALERS_FAILED";

export const LOAD_PARTNER_LOGS_STARTED = "LOAD_PARTNER_LOGS_STARTED";
export const LOAD_PARTNER_LOGS_SUCCEEDED = "LOAD_PARTNER_LOGS_SUCCEEDED";
export const LOAD_PARTNER_LOGS_FAILED = "LOAD_PARTNER_LOGS_FAILED";
export const PARTNER_LOG_LIST_INVALIDATED = "PARTNER_LOG_LIST_INVALIDATED";

export const LOAD_PARTNER_LOG_STARTED = "LOAD_PARTNER_LOG_STARTED";
export const LOAD_PARTNER_LOG_SUCCEEDED = "LOAD_PARTNER_LOG_SUCCEEDED";
export const LOAD_PARTNER_LOG_FAILED = "LOAD_PARTNER_LOG_FAILED";

export const LOAD_DEALER_CONTACT_MODES_STARTED = "LOAD_DEALER_CONTACT_MODES_STARTED";
export const LOAD_DEALER_CONTACT_MODES_SUCCEEDED = "LOAD_DEALER_CONTACT_MODES_SUCCEEDED";
export const LOAD_DEALER_CONTACT_MODES_FAILED = "LOAD_DEALER_CONTACT_MODES_FAILED";

export const LOAD_DEALER_CONTACT_INFOS_STARTED = "LOAD_DEALER_CONTACT_INFOS_STARTED";
export const LOAD_DEALER_CONTACT_INFOS_SUCCEEDED = "LOAD_DEALER_CONTACT_INFOS_SUCCEEDED";
export const LOAD_DEALER_CONTACT_INFOS_FAILED = "LOAD_DEALER_CONTACT_INFOS_FAILED";

export const UPDATE_DEALER_CONTACT_MODES_STARTED = "UPDATE_DEALER_CONTACT_MODES_STARTED";
export const UPDATE_DEALER_CONTACT_MODES_SUCCEEDED = "UPDATE_DEALER_CONTACT_MODES_SUCCEEDED";
export const UPDATE_DEALER_CONTACT_MODES_FAILED = "UPDATE_DEALER_CONTACT_MODES_FAILED";

export const UPDATE_DEALER_CONTACT_INFOS_STARTED = "UPDATE_DEALER_CONTACT_INFOS_STARTED";
export const UPDATE_DEALER_CONTACT_INFOS_SUCCEEDED = "UPDATE_DEALER_CONTACT_INFOS_SUCCEEDED";
export const UPDATE_DEALER_CONTACT_INFOS_FAILED = "UPDATE_DEALER_CONTACT_INFOS_FAILED";
